import { isMatch } from "date-fns/isMatch";

export function isDateOnlyString(value: string): boolean {
  return isMatch(value, "yyyy-MM-dd");
}
